export default class RentalcompanyCode {

    _item;

    constructor(item) {
        this._item = item;
    }

    get raw() {
        return this._item;
    }

}